import React, { useState } from 'react';
import { Heart, Sparkles, ArrowRight } from 'lucide-react';
import SimulatorQuestions from './SimulatorQuestions';
import SimulatorResults from './SimulatorResults';
import { calculateProfile } from '../../data/simulatorData';

const SimulatorPage = () => {
  const [stage, setStage] = useState('intro'); // intro, questions, results
  const [answers, setAnswers] = useState([]);
  const [result, setResult] = useState(null);

  const handleStart = () => {
    setStage('questions');
  };

  const handleComplete = (allAnswers) => {
    setAnswers(allAnswers);
    const profileResult = calculateProfile(allAnswers);
    setResult(profileResult);
    setStage('results');
    window.scrollTo(0, 0);
  };

  const handleRestart = () => {
    setAnswers([]);
    setResult(null);
    setStage('intro');
    window.scrollTo(0, 0);
  };

  const handleContact = () => {
    // Navigate to contact section or open modal
    window.location.href = '/#contact';
  };

  // Intro Stage
  if (stage === 'intro') {
    return (
      <div className="min-h-screen flex items-center justify-center px-6 py-20">
        <div className="max-w-2xl mx-auto text-center">
          {/* Icon */}
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#D4C4B0]/40 to-[#B5C4B1]/40 flex items-center justify-center mx-auto mb-8 shadow-lg">
            <Heart size={36} className="text-[#6B4E37]" />
          </div>

          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full text-sm text-[#8B7D6B] mb-6 shadow-sm">
            <Sparkles size={16} className="text-[#C4B5A0]" />
            Experiência interativa
          </div>

          {/* Title */}
          <h1 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl lg:text-6xl text-[#2C2C2C] mb-6 leading-tight">
            Simulador Emocional<br />do Casamento
          </h1>

          {/* Description */}
          <p className="text-lg md:text-xl text-[#6B4E37] mb-4 leading-relaxed">
            Descubram o vosso perfil de casamento e tomem decisões mais conscientes e alinhadas com os vossos valores.
          </p>
          <p className="text-[#8B7D6B] mb-10">
            8 perguntas · 5 minutos · Resultado personalizado
          </p>

          {/* Features */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12">
            <div className="bg-white/60 backdrop-blur-sm rounded-xl p-5">
              <div className="w-10 h-10 rounded-full bg-[#B5C4B1]/30 flex items-center justify-center mx-auto mb-3">
                <span className="text-lg">🎯</span>
              </div>
              <h3 className="font-medium text-[#2C2C2C] mb-1">Identifiquem</h3>
              <p className="text-sm text-[#8B7D6B]">O vosso perfil emocional e estratégico</p>
            </div>
            <div className="bg-white/60 backdrop-blur-sm rounded-xl p-5">
              <div className="w-10 h-10 rounded-full bg-[#D4C4B0]/30 flex items-center justify-center mx-auto mb-3">
                <span className="text-lg">💡</span>
              </div>
              <h3 className="font-medium text-[#2C2C2C] mb-1">Descubram</h3>
              <p className="text-sm text-[#8B7D6B]">Prioridades reais e pontos de atenção</p>
            </div>
            <div className="bg-white/60 backdrop-blur-sm rounded-xl p-5">
              <div className="w-10 h-10 rounded-full bg-[#E8D5D5]/30 flex items-center justify-center mx-auto mb-3">
                <span className="text-lg">✨</span>
              </div>
              <h3 className="font-medium text-[#2C2C2C] mb-1">Recebam</h3>
              <p className="text-sm text-[#8B7D6B]">Recomendações personalizadas</p>
            </div>
          </div>

          {/* CTA */}
          <button
            onClick={handleStart}
            className="inline-flex items-center gap-3 px-10 py-4 bg-[#C4B5A0] text-white rounded-lg font-medium text-lg hover:bg-[#6B4E37] transition-all duration-300 shadow-md hover:shadow-lg"
          >
            Começar o Simulador
            <ArrowRight size={22} />
          </button>

          {/* Note */}
          <p className="text-sm text-[#8B7D6B] mt-8">
            As vossas respostas são confidenciais e não são partilhadas.
          </p>
        </div>
      </div>
    );
  }

  // Questions Stage
  if (stage === 'questions') {
    return <SimulatorQuestions onComplete={handleComplete} />;
  }

  // Results Stage
  if (stage === 'results' && result) {
    return (
      <SimulatorResults 
        result={result} 
        answers={answers}
        onRestart={handleRestart}
        onContact={handleContact}
      />
    );
  }

  return null;
};

export default SimulatorPage;
